import { useEffect, useState } from "react";
// import style from "./reward.module.css";
import singhCoinCurrency from "assets/images/singhCoinCurrency.png";
import { Link, useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
// import InfoIcon from "@mui/icons-material/Info";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useMediaQuery } from "react-responsive";
import Card from "@mui/material/Card";
import MDAvatar from "components/MDAvatar";
import { Divider } from "@mui/material";
// import referearn from "assets/images/7121.jpg";
import { AppBar, Icon } from "@mui/material";
import TabPanel from "components/TabPanel";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import InfiniteScroll from "react-infinite-scroll-component";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import InsertCommentIcon from "@mui/icons-material/InsertComment";
import GridOnIcon from "@mui/icons-material/GridOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import coin from "assets/images/singhCoinCurrency.png";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllReward } from "Store/slices/rewardSlice";
import nftWhite from "../../assets/images/nftLogoWhite.svg";
import { fetchClaimHistory } from "Store/slices/rewardSlice";
import { getRewardsClaimHistory } from "services/rewardService";
import SpinLoader from "components/SpinLoader";
import { claimHistoryReducerPlus } from "Store/slices/rewardSlice";
import ClaimedCards from "./components/claimedCards";
import EarnedCards from "./components/EarnedCards";

const Rewards = () => {
  const dispatch = useDispatch();
  const {
    allRewardsEarned,
    totalRewardsEarned,
    balanceReward,
    claimHistory,
    claimHistoryPageNumber,
    isRewardLoading,
    isAllRewardLoading,
    isClaimHistoryLoading,
  } = useSelector((state) => state.userRewards);

  //   const [reward, setReward] = useState(0);
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);
  const [tabsLoader, setTabsLoader] = useState(true);
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    fetchAllRewardData();
  }, []);

  const fetchAllRewardData = () => {
    dispatch(fetchAllReward());
    dispatch(fetchClaimHistory(1));
  };

  const handleInfo = () => {
    navigate("/info");
  };

  const handleRewardHistory = () => {
    navigate("/reward-widget");
  };

  const handleClaim = () => {
    navigate("/claim");
  };

  const handleLikeClick = () => {
    navigate(`/reward-details`);
  };
  const handleEarnsinghClick = () => {
    navigate(`/earn-singh`);
  };

  // const fetchMoreClaimHistory = async (number) => {
  //   const getClaimHistoryRes = await getRewardsClaimHistory(number);

  //   console.log("getClaimHistoryRes", getClaimHistoryRes);

  //   if (getClaimHistoryRes.status === 200) {
  //     dispatch(
  //       claimHistoryReducerPlus(getClaimHistoryRes.data[0].claimRequest)
  //     );
  //   }
  // };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        {!isRewardLoading && !isAllRewardLoading ? (
          <Card
            sx={{
              backgroundColor: "#1a1a1a",
              padding: 1,
            }}
          >
            <MDBox>
              <MDBox sx={{ display: "flex", justifyContent: "center" }}>
                <MDTypography>Total Rewards Earned</MDTypography>
              </MDBox>

              <MDBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <MDAvatar
                  sx={{ cursor: "pointer" }}
                  //   onClick={() => handleUsernameClick(item.username)}
                  size="md"
                  src={singhCoinCurrency}
                  imgProps={{
                    style: { height: "100%", width: "100%" },
                  }}
                />

                <MDTypography
                  variant="h3"
                  // color="white"
                  // mt={1}
                  // sx={{ fontSize: "3rem" }}
                >
                  {isRewardLoading ? (
                    <CircularProgress size={15} color="inherit" />
                  ) : totalRewardsEarned !== 0 ? (
                    Number(totalRewardsEarned).toFixed(2)
                  ) : (
                    totalRewardsEarned
                  )}
                </MDTypography>
              </MDBox>
            </MDBox>
            <Divider />
            <MDBox paddingRight="3rem" paddingLeft="3rem">
              <MDBox sx={{ display: "flex", alignItems: "center" }}>
                <MDTypography
                  variant="h6"
                  fontWeight="medium"
                  color="white"
                  sx={{ fontSize: "20px" }}
                >
                  Available to claim
                </MDTypography>

                <IconButton
                  color="white"
                  onClick={() => handleEarnsinghClick()}
                >
                  <InfoOutlinedIcon color="inherit" />
                </IconButton>
              </MDBox>
              <MDBox sx={{ display: "flex", justifyContent: "space-between" }}>
                <MDBox sx={{ display: "flex", alignItems: "center" }}>
                  <MDAvatar
                    sx={{ cursor: "pointer" }}
                    //   onClick={() => handleUsernameClick(item.username)}
                    size="md"
                    src={singhCoinCurrency}
                    imgProps={{
                      style: {
                        height: "100%",
                        width: "100%",
                      },
                    }}
                  />
                  <MDTypography color="white">
                    {isRewardLoading ? (
                      <CircularProgress size={15} color="inherit" />
                    ) : balanceReward !== 0 ? (
                      Number(balanceReward).toFixed(2)
                    ) : (
                      balanceReward
                    )}
                  </MDTypography>
                </MDBox>
                <MDButton
                  variant="outlined"
                  color="singh"
                  onClick={() => handleClaim()}
                >
                  Claim
                </MDButton>
              </MDBox>
            </MDBox>
            <Divider />
            <MDBox>
              <MDBox marginBottom="1rem" textAlign="center">
                <MDTypography
                  variant="h6"
                  fontWeight="medium"
                  color="white"
                  sx={{ fontSize: "20px" }}
                >
                  Reward History
                </MDTypography>
              </MDBox>
              <MDBox>
                <AppBar position="static" sx={{}}>
                  <Tabs
                    // inkBarStyle={{ backgroundColor: "red" }}
                    value={tabValue}
                    onChange={handleSetTabValue}
                  >
                    <Tab label="Earned" />
                    <Tab label="Claimed" />
                  </Tabs>
                </AppBar>

                <TabPanel value={tabValue} index={0}>
                  <Grid
                    container
                    sx={{
                      justifyContent: "center",
                      gap: "30px",
                      padding: "1rem",
                      //   rowGap: "35px",
                      //   marginLeft: "30px",
                      //   marginRight: "30px",
                    }}
                  >
                    <Grid item xs={5} md={3}>
                      <EarnedCards
                        icon={<FavoriteIcon />}
                        title="Like"
                        value={allRewardsEarned.likePoints}
                        route={`/reward-details?type=like`}
                      />
                    </Grid>
                    <Grid item xs={5} md={3}>
                      <EarnedCards
                        icon={<InsertCommentIcon />}
                        title="Comments"
                        value={allRewardsEarned.commentPoints}
                        route={`/reward-details?type=comment`}
                      />
                    </Grid>
                    <Grid item xs={5} md={3}>
                      <EarnedCards
                        icon={<GridOnIcon />}
                        title="Post"
                        value={allRewardsEarned.postPoints}
                        route={`/reward-details?type=posts`}
                      />
                    </Grid>
                    <Grid item xs={5} md={3}>
                      <EarnedCards
                        icon={<img src={nftWhite} height="25px" width="25px" />}
                        title="NFT"
                        value={allRewardsEarned.NFTsPoints}
                        route={`/reward-details?type=nft`}
                      />
                    </Grid>
                    <Grid item xs={5} md={3}>
                      <EarnedCards
                        icon={<CalendarTodayIcon />}
                        title="Events"
                        value={allRewardsEarned.eventCreatedPoints}
                        route={`/reward-details?type=event`}
                      />
                    </Grid>
                    <Grid item xs={5} md={3}>
                      <EarnedCards
                        icon={<EmojiPeopleIcon />}
                        title="Engagement"
                        value={allRewardsEarned.EngagementPoints}
                        route={`/reward-details?type=engagement`}
                      />
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                  {isClaimHistoryLoading ? (
                    <MDBox
                      sx={{
                        height: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <MDTypography color="singh">
                        <CircularProgress color="inherit" />
                      </MDTypography>
                    </MDBox>
                  ) : claimHistory.length > 0 ? (
                    <MDBox display="flex" flexDirection="column">
                      {claimHistory.map((item, idx) => (
                        <ClaimedCards
                          key={idx}
                          color="success"
                          icon={<AccessTimeIcon fontSize="inherit" />}
                          name={
                            item.status === "pending"
                              ? "Requested"
                              : item.status
                          }
                          description={item.walletAddress}
                          description2={item.claimTime}
                          value={item.claimAmount}
                        />
                      ))}
                    </MDBox>
                  ) : (
                    <MDBox sx={{ textAlign: "center" }}>
                      <MDTypography color="text" sx={{ marginTop: "4rem" }}>
                        No Claim History found
                      </MDTypography>
                    </MDBox>
                  )}
                </TabPanel>
              </MDBox>
            </MDBox>
          </Card>
        ) : (
          <MDBox
            sx={{
              height: "500px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <MDTypography color="singh">
              <CircularProgress color="inherit" />
            </MDTypography>
          </MDBox>
        )}
      </MDBox>
    </DashboardLayout>
  );
};

export default Rewards;
